const basicDetailsSchema = Object.seal({
    feilds: [{
        id: 1,
        name: 'counselling_date',
        title: 'Date of Counselling *',
        visible: true,
        element: 'datepicker',
        required: false,
        type: 'text',
        placeholder: 'Select',
        icon: 'user',
        rules: [{
            test: (value) => {
                return (value !== null && value.length > 0 && value != '');
            },
            message: 'Please Enter Date of Counselling'
        }],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-3 mt-3'
    }, {
        id: 1,
        name: 'token_number',
        title: 'Token Number *',
        visible: true,
        element: 'input',
        required: false,
        type: 'text',
        placeholder: 'Enter',
        icon: 'user',
        rules: [{
            test: (value) => {
                return (value !== null && value.length > 0 && value != '');
            },
            message: 'Please Enter Token Number'
        }],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-3 mt-3'
    }, {
        id: 12,
        name: 'counselling_type',
        title: 'Counselling Type *',
        visible: true,
        element: 'select',
        required: false,
        type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [{
            test: (value) => {
                return (value !== null && value.length > 0 && value != '');
            },
            message: 'Please Enter Counselling Type'
        }],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 13,
        name: 'ip_number',
        title: 'IP Number',
        visible: true,
        element: 'input',
        required: false,
        type: 'text',
        placeholder: 'Select',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-3 mt-3'
    }, {
        id: 7,
        name: 'umr_number',
        title: 'UMR Number *',
        visible: true,
        element: 'input',
        required: false,
        type: 'text',
        placeholder: 'Enter',
        icon: 'user',
        rules: [{
            test: (value) => {
                return (value !== null && value.length > 0 && value != '');
            },
            message: 'Please Enter UMR Number'
        }],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-3 mt-3'
    }, {
        id: 2,
        name: 'patient_name',
        title: 'Patient name *',
        visible: true,
        element: 'input',
        required: false,
        type: 'text',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-3 mt-3'
    }, {
        id: 3,
        name: 'age',
        title: 'Age *',
        visible: true,
        element: 'input',
        required: false,
        type: 'text',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-3 mt-3'
    }, {
        id: 4,
        name: 'gender',
        title: 'Gender *',
        visible: true,
        element: 'input',
        required: false,
        type: 'text',
        placeholder: 'Select',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-3 mt-3'
    }, {
        id: 8,
        name: 'phone_number',
        title: 'Phone Number *',
        visible: true,
        element: 'input',
        required: false,
        type: 'text',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-3 mt-3'
    }, {
        id: 14,
        name: 'marital_status',
        title: 'Marital Status',
        visible: true,
        element: 'input',
        required: false,
        type: 'text',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-3 mt-3'
    }, {
        id: 9,
        name: 'doctor_name',
        title: 'Doctor Name *',
        visible: true,
        element: 'select',
        required: false,
        type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 10,
        name: 'speciality',
        title: 'Speciality *',
        visible: true,
        element: 'input',
        required: false,
        type: 'text',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-3 mt-3'
    },  {
        id: 15,
        name: 'address',
        title: 'Address',
        visible: true,
        element: 'input',
        required: false,
        type: 'text',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-9 mt-3'
    },{
        id: 16,
        name: 'payment_mode',
        title: 'Mode of Payment *',
        visible: true,
        element: 'select',
        required: false,
        type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    },]
})

const employeeDetailsSchema = Object.seal({
    feilds: [ {
        id: 5,
        name: 'estimated_admission_date',
        title: 'Estimated Date of Admission *',
        visible: true,
        element: 'datepicker',
        required: false,
        type: 'datepicker',
        placeholder: 'Select',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 6,
        name: 'actual_admission_date',
        title: 'Actual Date of Admission',
        visible: true,
        element: 'datepicker',
        required: false,
        type: 'datepicker',
        placeholder: 'Select',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 11,
        name: 'diagnosis',
        title: 'Diagnosis',
        visible: true,
        element: 'input',
        required: false,
        type: 'text',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 17,
        name: 'organization',
        title: 'Organization Name *',
        visible: true,
        element: 'select',
        required: false,
        type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 18,
        name: 'payment_cashless',
        title: 'On Payment/Cashless *',
        visible: true,
        element: 'select',
        required: false,
        type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 19,
        name: 'self_dependant',
        title: 'Self/Dependant *',
        visible: true,
        element: 'select',
        required: false,
        type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 20,
        name: 'emp_working_status',
        title: 'Empolyee Working Status *',
        visible: true,
        element: 'select',
        required: false,
        type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 21,
        name: 'member_relationship',
        title: 'Relationship With Member *',
        visible: true,
        element: 'select',
        required: false,
        type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 22,
        name: 'disability',
        title: 'Disability *',
        visible: true,
        element: 'select',
        required: false,
        type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 23,
        name: 'emp_name',
        title: 'Employee Name *',
        visible: true,
        element: 'input',
        required: false,
        type: 'text',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 24,
        name: 'emp_salary',
        title: 'Salary',
        visible: true,
        element: 'input',
        required: false,
        type: 'number',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 23,
        name: 'emp_grade',
        title: 'Employee Grade',
        visible: true,
        element: 'select',
        required: false,
        type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 23,
        name: 'emp_designation',
        title: 'Employee Designation *',
        visible: true,
        element: 'select',
        required: false,
        type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 25,
        name: 'emp_id',
        title: 'Employee ID *',
        visible: true,
        element: 'input',
        required: false,
        type: 'text',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    },]
})

const medicationDetailsSchema = Object.seal({
    feilds: [{
        id: 16,
        name: 'care_management',
        title: 'Care Management *',
        visible: true,
        element: 'select',
        required: false,
        type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 16,
        name: 'dialysis_radiation',
        title: 'Dialysis/Radiation *',
        visible: false,
        element: 'select',
        required: false,
        type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 17,
        name: 'estimate_type',
        title: 'Estimate Type *',
        visible: false,
        element: 'select',
        required: false,
        type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 18,
        name: 'package_name',
        title: 'Package Name *',
        visible: false,
        element: 'select',
        required: false,
        type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 19,
        name: 'length_of_stay',
        title: 'Length of Stay *',
        visible: true,
        element: 'input',
        required: true,
        type: 'number',
        placeholder: 'Enter',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0 && value != '');
                },
                message: 'Please Enter Length of Stay'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-3 mt-3'
    }, {
        id: 20,
        name: 'icu_stay',
        title: 'ICU Stay *',
        visible: false,
        element: 'input',
        required: false,
        type: 'number',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 21,
        name: 'room_stay',
        title: 'Room Stay *',
        visible: false,
        element: 'input',
        required: false,
        type: 'number',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 22,
        name: 'date_of_surgery',
        title: 'Date of Surgery *',
        visible: false,
        element: 'datepicker',
        required: false,
        type: 'datepicker',
        placeholder: 'Select',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 23,
        name: 'surgery_procedure_name',
        title: 'Surgery/Procedure Name *',
        visible: false,
        element: 'select',
        required: false,
        type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 24,
        name: 'additional_procedure',
        title: 'Additional Procedure',
        visible: true,
        element: 'select',
        required: false,
        type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 25,
        name: 'additional_procedure_amount',
        title: 'Additional Procedure Amount',
        visible: true,
        element: 'input',
        required: false,
        type: 'number',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 26,
        name: 'additional_package',
        title: 'Additional Package',
        visible: true,
        element: 'select',
        required: false,
        type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 27,
        name: 'additional_package_amount',
        title: 'Additional Package Amount',
        visible: true,
        element: 'input',
        required: false,
        type: 'number',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    },]
})

const estimateBreakupFormatSchema = Object.seal({
    feilds: [{
        id: 1,
        name: 'room_eligibility',
        title: 'Room Eligibility *',
        visible: true,
        element: 'select',
        required: false,
        type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 29,
        name: 'room_upgrade',
        title: 'Room Upgrade',
        visible: true,
        element: 'select',
        required: false,
        type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 30,
        name: 'room_difference',
        title: 'Room Difference',
        visible: true,
        element: 'input',
        required: false,
        type: 'number',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-3 mt-3'
    }, {
        id: 2,
        name: 'coverage_amount',
        title: 'Couverage Amount',
        visible: true,
        element: 'input',
        required: false,
        type: 'number',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 3,
        name: 'device_type',
        title: 'Device type',
        visible: true,
        element: 'select',
        required: false,
        type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 4,
        name: 'eligible_cost',
        title: 'Eligible Cost',
        visible: true,
        element: 'input',
        required: false,
        type: 'number',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 5,
        name: 'upgraded_implant',
        title: 'Upgraded Implant',
        visible: true,
        element: 'select',
        required: false,
        type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 6,
        name: 'upgraded_cost',
        title: 'Upgraded Cost',
        visible: true,
        element: 'input',
        required: false,
        type: 'number',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 7,
        name: 'stent_implant_difference',
        title: 'Stent/implant Difference',
        visible: true,
        element: 'input',
        required: false,
        type: 'number',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 8,
        name: 'ref_letter_number',
        title: 'Referral Letter Number *',
        visible: true,
        element: 'input',
        required: false,
        type: 'text',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 8,
        name: 'ref_letter_date',
        title: 'Referral Letter Date *',
        visible: true,
        element: 'datepicker',
        required: false,
        type: 'datepicker',
        placeholder: 'Select',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 8,
        name: 'ref_letter_expiry_date',
        title: 'Referral Letter Expiry Date *',
        visible: true,
        element: 'datepicker',
        required: false,
        type: 'datepicker',
        placeholder: 'Select',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 8,
        name: 'nme',
        title: 'NME',
        visible: true,
        element: 'input',
        required: false,
        type: 'number',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 8,
        name: 'co_pay_amount',
        title: 'Co Pay Amount',
        visible: true,
        element: 'input',
        required: false,
        type: 'number',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 8,
        name: 'company_coverage_diff_amount',
        title: 'Company Coverage Diff. Amount',
        visible: true,
        element: 'input',
        required: false,
        type: 'number',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 8,
        name: 'others',
        title: 'others',
        visible: true,
        element: 'input',
        required: false,
        type: 'number',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 8,
        name: 'total_estimate_amount',
        title: 'Total Estimate Amount',
        visible: true,
        element: 'input',
        required: false,
        type: 'number',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 8,
        name: 'clearence_option',
        title: 'Clearance Option',
        visible: true,
        element: 'select',
        required: false,
        type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 8,
        name: 'fc-name',
        title: 'FC Name',
        visible: true,
        element: 'input',
        required: false,
        type: 'text',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 8,
        name: 'attendant_name',
        title: 'Attendant Name',
        visible: true,
        element: 'input',
        required: false,
        type: 'text',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 8,
        name: 'attendant_relation',
        title: 'Attendant Relation',
        visible: true,
        element: 'input',
        required: false,
        type: 'text',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }]
})

const addonSchema = {
    feilds: [{
        id: 1,
        name: 'room_charges',
        title: 'Room charges',
        visible: true,
        Specification: {
            'type': 'table',
            'add_more': false,
            'add_more_title': null,
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Service Name', width: "30%" }, { 'id': 3, 'text': 'Quantity', width: "15%" }, { 'id': 4, 'text': 'Rate (Rs.)', width: "15%" }, { 'id': 5, 'text': 'Amount (Rs.)', width: "35%" }],
            'table_body': [{
                'id:': 1,

                'feilds': [{
                    id: 1,
                    name: 'room',
                    title: 'Room',
                    visible: true,
                    element: 'text',

                }, {
                    id: 1,
                    name: 'room_charges_qty',
                    title: 'Room Charges Qty.',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Room Charges Quantity',
                    rules: [],
                    errors: [],
                    value: 0,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'Room',
                    column_group: 'qty',
                }, {
                    id: 1,
                    name: 'room_charges_rate',
                    title: 'Room Charges Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Room Charges Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'Room',
                    column_group: 'rate',
                }, {
                    id: 1,
                    name: 'room_charges_amount',
                    title: 'Room Charges Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Room Charges Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'Room',
                    column_group: 'amount',
                }]
            }, {
                'id:': 2,

                'feilds': [{
                    id: 1,
                    name: 'icu',
                    title: 'ICU',
                    visible: true,
                    element: 'text',

                }, {
                    id: 2,
                    name: 'icu_charges_qty',
                    title: 'ICU Charges Qty.',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'ICU Charges Quantity',
                    rules: [],
                    errors: [],
                    value: 0,
                    valid: false,
                    state: '',

                    disable: true,
                    className: 'col-3',
                    row_group: 'ICU',
                    column_group: 'qty',
                }, {
                    id: 2,
                    name: 'icu_charges_rate',
                    title: 'ICU Charges Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'ICU Charges Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'ICU',
                    column_group: 'rate',
                }, {
                    id: 2,
                    name: 'icu_charges_amount',
                    title: 'ICU Charges Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'ICU Charges Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'ICU',
                    column_group: 'amount',
                }]
            }],
            'add_more_feilds': [],
        }
    }, {
        id: 2,
        name: 'room_investigation_charges',
        title: 'Room Investigation Charges',
        visible: true,
        Specification: {
            'type': 'table',
            'add_more': true,
            'add_more_title': 'Add Highend Room Investigation',
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Service Name', width: "30%" }, { 'id': 3, 'text': 'Quantity', width: "15%" }, { 'id': 4, 'text': 'Rate (Rs.)', width: "15%" }, { 'id': 5, 'text': 'Amount (Rs.)', width: "28%" }, { 'id': 6, 'text': 'Action', width: "7%" }],
            'table_body': [{
                'id:': 1,
                'text': 'Routine',
                'type': 'text',
                'input_feild': [],
                'feilds': [{
                    id: 1,
                    name: 'Routine',
                    title: 'Routine',
                    visible: true,
                    element: 'text',

                }, {
                    id: 1,
                    name: 'qty',
                    title: '',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine Room Investigation Quantity',
                    rules: [],
                    errors: [],
                    value: 0,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'w-100',
                    row_group: 'Routine',
                    column_group: 'qty',
                }, {
                    id: 1,
                    name: 'rate',
                    title: 'Routine Room Investigation Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine Room Investigation Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'Routine',
                    column_group: 'rate',
                }, {
                    id: 1,
                    name: 'amount',
                    title: 'Routine Room Investigation Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine Room Investigation Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'Routine',
                    column_group: 'amount',
                }, {
                    id: 1,
                    name: 'action',
                    title: '--',
                    visible: true,
                    element: 'text',

                },]
            }, ],
            'add_more_feilds': [{
                id: 1,
                name: 'ricam_choose',
                title: '',
                visible: true,
                icon: 'number',
                element: 'select',
                required: true,
                type: 'select',
                placeholder: 'Highend Room Investigation',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: false,
                className: 'col-12 p-0',
                row_group: 'Highend',
                column_group: 'choose',
            }, {
                id: 1,
                name: 'qty',
                title: 'Highend Room Investigation Qty.',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Highend Room Investigation Quantity',
                rules: [],
                errors: [],
                value: 1,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'Highend',
                column_group: 'qty',
            }, {
                id: 1,
                name: 'rate',
                title: 'Highend Room Investigation Rate',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Highend Room Investigation Rate',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'Highend',
                column_group: 'rate',
            }, {
                id: 1,
                name: 'amount',
                title: 'Highend Room Investigation Amount',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Highend Room Investigation Amount',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'Highend',
                column_group: 'amount',
            }, {
                id: 1,
                name: 'action',
                title: '--',
                visible: true,
                element: 'action',

            }],
        }
    }, {
        id: 2,
        name: 'icu_investigation_charges',
        title: 'ICU Investigation Charges',
        visible: true,
        Specification: {
            'type': 'table',
            'add_more': true,
            'add_more_title': 'Add Highend ICU Investigation',
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Service Name', width: "30%" }, { 'id': 3, 'text': 'Quantity', width: "15%" }, { 'id': 4, 'text': 'Rate (Rs.)', width: "15%" }, { 'id': 5, 'text': 'Amount (Rs.)', width: "28%" }, { 'id': 6, 'text': 'Action', width: "7%" }],
            'table_body': [{
                'id:': 1,
                'text': 'Routine',
                'type': 'text',
                'input_feild': [],
                'feilds': [{
                    id: 1,
                    name: 'Routine',
                    title: 'Routine',
                    visible: true,
                    element: 'text',

                }, {
                    id: 1,
                    name: 'qty',
                    title: '',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine Room Investigation Quantity',
                    rules: [],
                    errors: [],
                    value: 0,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'w-100',
                    row_group: 'Routine',
                    column_group: 'qty',
                }, {
                    id: 1,
                    name: 'rate',
                    title: 'Routine Room Investigation Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine Room Investigation Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'Routine',
                    column_group: 'rate',
                }, {
                    id: 1,
                    name: 'amount',
                    title: 'Routine Room Investigation Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine Room Investigation Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'Routine',
                    column_group: 'amount',
                }, {
                    id: 1,
                    name: 'action',
                    title: '--',
                    visible: true,
                    element: 'text',

                },]
            }],
            'add_more_feilds': [{
                id: 1,
                name: 'ricam_choose',
                title: '',
                visible: true,
                icon: 'number',
                element: 'select',
                required: true,
                type: 'select',
                placeholder: 'Highend Room Investigation',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: false,
                className: 'col-12 p-0',
                row_group: 'Highend',
                column_group: 'choose',
            }, {
                id: 1,
                name: 'qty',
                title: 'Highend Room Investigation Qty.',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Highend Room Investigation Quantity',
                rules: [],
                errors: [],
                value: 1,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'Highend',
                column_group: 'qty',
            }, {
                id: 1,
                name: 'rate',
                title: 'Highend Room Investigation Rate',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Highend Room Investigation Rate',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'Highend',
                column_group: 'rate',
            }, {
                id: 1,
                name: 'amount',
                title: 'Highend Room Investigation Amount',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Highend Room Investigation Amount',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'Highend',
                column_group: 'amount',
            }, {
                id: 1,
                name: 'action',
                title: '--',
                visible: true,
                element: 'action',

            }],
        }
    }, {
        id: 3,
        name: 'ip_pharmacy_charges',
        title: 'IP Pharmacy charges',
        visible: true,
        Specification: {
            'type': 'table',
            'add_more': false,
            'add_more_title': 'Add Highend Room Investigation',
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Service Name', width: "30%" }, { 'id': 3, 'text': 'Quantity', width: "15%" }, { 'id': 4, 'text': 'Rate (Rs.)', width: "15%" }, { 'id': 5, 'text': 'Amount (Rs.)', width: "35%" }],
            'table_body': [{
                'id:': 1,
                'feilds': [{
                    id: 1,
                    name: 'routine_drugs_implants',
                    title: 'Routine Drugs & Implants',
                    visible: true,
                    element: 'text',

                }, {
                    id: 1,
                    name: 'qty',
                    title: 'Routine Drugs & Implants Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine Drugs & Implants Quantity',
                    rules: [],
                    errors: [],
                    value: 0,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'Room',
                    column_group: 'qty',
                }, {
                    id: 1,
                    name: 'rate',
                    title: 'Routine Drugs & Implants Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine Drugs & Implants Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'Room',
                    column_group: 'rate',
                }, {
                    id: 1,
                    name: 'amount',
                    title: 'Routine Drugs & Implants Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine Drugs & Implants Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'Room',
                    column_group: 'amount',
                }]
            }   , {
                'id:': 2,
                'feilds': [{
                    id: 2,
                    name: 'ricam_choose',
                    title: 'Highend Drugs & Implants',
                    visible: true,
                    icon: 'number',
                    element: 'select',
                    required: true,
                    type: 'select',
                    placeholder: 'Highend Drugs & Implants',
                    rules: [],
                    errors: [],
                    value: 1,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'ICU',
                    column_group: 'qty',
                }, {
                    id: 2,
                    name: 'qty',
                    title: 'Highend Drugs & Implants Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Highend Drugs & Implants Quantity',
                    rules: [],
                    errors: [],
                    value: 1,
                    valid: false,
                    state: '',

                    disable: false,
                    className: 'col-3',
                    row_group: 'ICU',
                    column_group: 'qty',
                }, {
                    id: 2,
                    name: 'rate',
                    title: 'Highend Drugs & Implants Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Highend Drugs & Implants Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'ICU',
                    column_group: 'rate',
                }, {
                    id: 2,
                    name: 'amount',
                    title: 'Highend Drugs & Implants Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Highend Drugs & Implants Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'ICU',
                    column_group: 'amount',
                }]
            }]
        }
    }, {
        id: 4,
        name: 'icu_pharmacy_charges',
        title: 'ICU Pharmacy charges',
        visible: true,
        Specification: {
            'type': 'table',
            'add_more': false,
            'add_more_title': null,
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Service Name', width: "30%" }, { 'id': 3, 'text': 'Quantity', width: "15%" }, { 'id': 4, 'text': 'Rate (Rs.)', width: "15%" }, { 'id': 5, 'text': 'Amount (Rs.)', width: "35%" }],
            'table_body': [{
                'id:': 1,
                'feilds': [{
                    id: 1,
                    name: 'routine_drugs_implants',
                    title: 'Routine Drugs & Implants',
                    visible: true,
                    element: 'text',

                }, {
                    id: 1,
                    name: 'qty',
                    title: 'Routine Drugs & Implants Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine Drugs & Implants Quantity',
                    rules: [],
                    errors: [],
                    value: 0,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'Room',
                    column_group: 'qty',
                }, {
                    id: 1,
                    name: 'rate',
                    title: 'Routine Drugs & Implants Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine Drugs & Implants Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'Room',
                    column_group: 'rate',
                }, {
                    id: 1,
                    name: 'amount',
                    title: 'Routine Drugs & Implants Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine Drugs & Implants Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'Room',
                    column_group: 'amount',
                }]
            }, {
                'id:': 2,
                'feilds': [{
                    id: 2,
                    name: 'ricam_choose',
                    title: 'Highend Drugs & Implants',
                    visible: true,
                    icon: 'number',
                    element: 'select',
                    required: true,
                    type: 'select',
                    placeholder: 'Highend Drugs & Implants',
                    rules: [],
                    errors: [],
                    value: 1,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'ICU',
                    column_group: 'qty',
                }, {
                    id: 2,
                    name: 'qty',
                    title: 'Highend Drugs & Implants Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Highend Drugs & Implants Quantity',
                    rules: [],
                    errors: [],
                    value: 1,
                    valid: false,
                    state: '',

                    disable: false,
                    className: 'col-3',
                    row_group: 'ICU',
                    column_group: 'qty',
                }, {
                    id: 2,
                    name: 'rate',
                    title: 'Highend Drugs & Implants Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Highend Drugs & Implants Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'ICU',
                    column_group: 'rate',
                }, {
                    id: 2,
                    name: 'amount',
                    title: 'Highend Drugs & Implants Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Highend Drugs & Implants Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'ICU',
                    column_group: 'amount',
                }]
            }]
        }
    }, {
        id: 5,
        name: 'ot_cath_pharmacy',
        title: 'OT/Cath Pharmacy',
        visible: true,
        Specification: {
            'type': 'table',
            'add_more': false,
            'add_more_title': null,
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Service Name', width: "30%" }, { 'id': 3, 'text': 'Quantity', width: "15%" }, { 'id': 4, 'text': 'Rate (Rs.)', width: "15%" }, { 'id': 5, 'text': 'Amount (Rs.)', width: "35%" }],
            'table_body': [{
                'id:': 1,
                'feilds': [{
                    id: 1,
                    name: 'routine',
                    title: 'Routine',
                    visible: true,
                    element: 'text',

                }, {
                    id: 1,
                    name: 'qty',
                    title: 'Routine Drugs & Implants Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine Drugs & Implants Quantity',
                    rules: [],
                    errors: [],
                    value: 1,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'Room',
                    column_group: 'qty',
                }, {
                    id: 1,
                    name: 'rate',
                    title: 'Routine Drugs & Implants Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine Drugs & Implants Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'Room',
                    column_group: 'rate',
                }, {
                    id: 1,
                    name: 'amount',
                    title: 'Routine Drugs & Implants Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine Drugs & Implants Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'Room',
                    column_group: 'amount',
                }]
            }, {
                'id:': 2,
                'feilds': [{
                    id: 2,
                    name: 'ricam_choose',
                    title: 'Highend Drugs & Implants',
                    visible: true,
                    icon: 'number',
                    element: 'select',
                    required: true,
                    type: 'select',
                    placeholder: 'Highend Drugs & Implants',
                    rules: [],
                    errors: [],
                    value: 1,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'ICU',
                    column_group: 'qty',
                }, {
                    id: 2,
                    name: 'qty',
                    title: 'Highend Drugs & Implants Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Highend Drugs & Implants Quantity',
                    rules: [],
                    errors: [],
                    value: 1,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'ICU',
                    column_group: 'qty',
                }, {
                    id: 2,
                    name: 'rate',
                    title: 'Highend Drugs & Implants Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Highend Drugs & Implants Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'ICU',
                    column_group: 'rate',
                }, {
                    id: 2,
                    name: 'amount',
                    title: 'Highend Drugs & Implants Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Highend Drugs & Implants Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'ICU',
                    column_group: 'amount',
                }]
            }]
        }
    }, {
        id: 7,
        name: 'general_equipment_charges',
        title: 'General Equipment Charges',
        visible: true,
        Specification: {
            'type': 'table',
            'add_more': false,
            'add_more_title': null,
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Service Name', width: "30%" }, { 'id': 3, 'text': 'Quantity', width: "15%" }, { 'id': 4, 'text': 'Rate (Rs.)', width: "15%" }, { 'id': 5, 'text': 'Amount (Rs.)', width: "35%" }],
            'table_body': [{
                'id:': 1,
                'feilds': [{
                    id: 1,
                    name: 'routine_equipment',
                    title: 'Routine Equipment',
                    visible: true,
                    element: 'text',

                }, {
                    id: 1,
                    name: 'qty',
                    title: 'Routine Equipment Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine Equipment Quantity',
                    rules: [],
                    errors: [],
                    value: 0,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'Room',
                    column_group: 'qty',
                }, {
                    id: 1,
                    name: 'rate',
                    title: 'Routine Equipment Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine Equipment Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'Room',
                    column_group: 'rate',
                }, {
                    id: 1,
                    name: 'amount',
                    title: 'Routine Equipment Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine Equipment Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'Room',
                    column_group: 'amount',
                }]
            }, {
                'id:': 2,
                'feilds': [{
                    id: 2,
                    name: 'ricam_choose',
                    title: 'Highend Drugs & Implants',
                    visible: true,
                    icon: 'number',
                    element: 'select',
                    required: true,
                    type: 'select',
                    placeholder: 'Highend Drugs & Implants',
                    rules: [],
                    errors: [],
                    value: 1,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'ICU',
                    column_group: 'qty',
                }, {
                    id: 2,
                    name: 'qty',
                    title: 'Highend Equipment Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Highend Equipment Quantity',
                    rules: [],
                    errors: [],
                    value: 1,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'ICU',
                    column_group: 'qty',
                }, {
                    id: 2,
                    name: 'rate',
                    title: 'Highend Equipment Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Highend Equipment Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'ICU',
                    column_group: 'rate',
                }, {
                    id: 2,
                    name: 'amount',
                    title: 'Highend Equipment Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Highend Equipment Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'ICU',
                    column_group: 'amount',
                }]
            }]
        }
    }, {
        id: 8,
        name: 'ot_charges',
        title: 'OT Charges',
        visible: true,
        Specification: {
            'type': 'table',
            'add_more': false,
            'add_more_title': null,
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Service Name', width: "30%" }, { 'id': 3, 'text': 'Quantity', width: "15%" }, { 'id': 4, 'text': 'Rate (Rs.)', width: "15%" }, { 'id': 5, 'text': 'Amount (Rs.)', width: "35%" }],
            'table_body': [{
                'id:': 1,
                'feilds': [{
                    id: 1,
                    name: 'ot_hours',
                    title: 'OT Hours',
                    visible: true,
                    element: 'text',

                }, {
                    id: 1,
                    name: 'ot_hours_qty',   
                    title: 'OT Hours Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'select',
                    required: true,
                    type: 'select',
                    placeholder: 'OT Hours Quantity',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'Room',
                    column_group: 'qty',
                }, {
                    id: 1,
                    name: 'rate',
                    title: 'OT Hours Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'OT Hours Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'Room',
                    column_group: 'rate',
                }, {
                    id: 1,
                    name: 'amount',
                    title: 'OT Hours Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'OT Hours Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'Room',
                    column_group: 'amount',
                }]
            }]
        }
    }, {
        id: 9,
        name: 'ot_equipment',
        title: 'OT Equipment',
        visible: true,
        Specification: {
            'type': 'table',
            'add_more': false,
            'add_more_title': null,
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Service Name', width: "30%" }, { 'id': 3, 'text': 'Quantity', width: "15%" }, { 'id': 4, 'text': 'Rate (Rs.)', width: "15%" }, { 'id': 5, 'text': 'Amount (Rs.)', width: "35%" }],
            'table_body': [{
                'id:': 1,
                'text': 'OT Equipment',
                'type': 'text',
                'input_feild': [],
                'feilds': [{
                    id: 1,
                    name: 'ricam_choose',
                    title: '',
                    visible: true,
                    icon: 'number',
                    element: 'select',
                    required: true,
                    type: 'select',
                    placeholder: 'OT Equipment',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-12 p-0',
                    row_group: 'Highend',
                    column_group: 'choose',

                }, {
                    id: 1,
                    name: 'qty',
                    title: 'OT Equipment Qty.',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'OT Equipment Quantity',
                    rules: [],
                    errors: [],
                    value: 1,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'Highend',
                    column_group: 'qty',
                }, {
                    id: 1,
                    name: 'rate',
                    title: 'OT Equipment Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'OT Equipment Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'Highend',
                    column_group: 'rate',
                }, {
                    id: 1,
                    name: 'amount',
                    title: 'OT Equipment Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'OT Equipment Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'Highend',
                    column_group: 'amount',
                }]
            }]
        }
    }, {
        id: 10,
        name: 'procedure_charges',
        title: 'Procedure Charges',
        visible: true,
        Specification: {
            'type': 'table',
            'add_more': false,
            'add_more_title': null,
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Service Name', width: "30%" }, { 'id': 3, 'text': 'Quantity', width: "15%" }, { 'id': 4, 'text': 'Rate (Rs.)', width: "15%" }, { 'id': 5, 'text': 'Amount (Rs.)', width: "35%" }],
            'table_body': [{
                'id:': 1,
                'feilds': [{
                    id: 1,
                    name: 'ricam_choose',
                    title: 'Procedure',
                    visible: true,
                    icon: 'number',
                    element: 'select',
                    required: true,
                    type: 'select',
                    placeholder: 'Procedure',
                    rules: [],
                    errors: [],
                    value: 1,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'ICU',
                    column_group: 'qty',
                }, {
                    id: 1,
                    name: 'qty',
                    title: 'Procedure Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Procedure Quantity',
                    rules: [],
                    errors: [],
                    value: 1,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'Room',
                    column_group: 'qty',
                }, {
                    id: 1,
                    name: 'rate',
                    title: 'Procedure Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Procedure Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'Room',
                    column_group: 'rate',
                }, {
                    id: 1,
                    name: 'amount',
                    title: 'Procedure Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Procedure Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'Room',
                    column_group: 'amount',
                }]
            }]
        }
    }, {
        id: 11,
        name: 'blood_bank_charges',
        title: 'Blood Bank Charges',
        visible: true,
        Specification: {
            'type': 'table',
            'add_more': false,
            'add_more_title': null,
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Service Name', width: "30%" }, { 'id': 3, 'text': 'Quantity', width: "15%" }, { 'id': 4, 'text': 'Rate (Rs.)', width: "15%" }, { 'id': 5, 'text': 'Amount (Rs.)', width: "35%" }],
            'table_body': [{
                'id:': 1,
                'feilds': [{
                    id: 2,
                    name: 'ricam_choose',
                    title: 'Blood Bank Charges',
                    visible: true,
                    icon: 'number',
                    element: 'select',
                    required: true,
                    type: 'select',
                    placeholder: 'Blood Bank Charges',
                    rules: [],
                    errors: [],
                    value: 1,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'ICU',
                    column_group: 'qty',
                }, {
                    id: 1,
                    name: 'qty',
                    title: 'Blood Bank Charges Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Blood Bank Charges Quantity',
                    rules: [],
                    errors: [],
                    value: 1,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'Room',
                    column_group: 'qty',
                }, {
                    id: 1,
                    name: 'rate',
                    title: 'Blood Bank Charges Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Blood Bank Charges Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'Room',
                    column_group: 'rate',
                }, {
                    id: 1,
                    name: 'amount',
                    title: 'Blood Bank Charges Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Blood Bank Charges Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'Room',
                    column_group: 'amount',
                }]
            }]
        }
    }, {
        id: 12,
        name: 'cross_consultation_charges',
        title: 'Cross Consultation Charges',
        visible: true,
        Specification: {
            'type': 'table',
            'add_more': false,
            'add_more_title': null,
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Service Name', width: "30%" }, { 'id': 3, 'text': 'Quantity', width: "15%" }, { 'id': 4, 'text': 'Rate (Rs.)', width: "15%" }, { 'id': 5, 'text': 'Amount (Rs.)', width: "35%" }],
            'table_body': [{
                'id:': 1,
                'feilds': [{
                    id: 2,
                    name: 'ricam_choose',
                    title: 'Cross Consultation Charges',
                    visible: true,
                    icon: 'number',
                    element: 'select',
                    required: true,
                    type: 'select',
                    placeholder: 'Cross Consultation Charges',
                    rules: [],
                    errors: [],
                    value: 1,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'ICU',
                    column_group: 'qty',
                }, {
                    id: 1,
                    name: 'qty',
                    title: 'Cross Consultation Charges Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Cross Consultation Charges Quantity',
                    rules: [],
                    errors: [],
                    value: 1,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'Room',
                    column_group: 'qty',
                }, {
                    id: 1,
                    name: 'rate',
                    title: 'Cross Consultation Charges Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Cross Consultation Charges Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'Room',
                    column_group: 'rate',
                }, {
                    id: 1,
                    name: 'amount',
                    title: 'Cross Consultation Charges Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Cross Consultation Charges Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'Room',
                    column_group: 'amount',
                }]
            }]
        }
    }, {
        id: 13,
        name: 'hospital_services',
        title: 'Hospital Services',
        visible: true,
        Specification: {
            'type': 'table',
            'add_more': false,
            'add_more_title': null,
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Service Name', width: "30%" }, { 'id': 3, 'text': 'Quantity', width: "15%" }, { 'id': 4, 'text': 'Rate (Rs.)', width: "15%" }, { 'id': 5, 'text': 'Amount (Rs.)', width: "35%" }],
            'table_body': [{
                'id:': 1,
                'feilds': [{
                    id: 2,
                    name: 'ricam_choose',
                    title: 'MRD',
                    visible: true,
                    icon: 'number',
                    element: 'select',
                    required: true,
                    type: 'select',
                    placeholder: 'MRD',
                    rules: [],
                    errors: [],
                    value: 1,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'ICU',
                    column_group: 'qty',
                }, {
                    id: 1,
                    name: 'qty',
                    title: 'MRD Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'MRD Quantity',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'Room',
                    column_group: 'qty',
                }, {
                    id: 1,
                    name: 'rate',
                    title: 'MRD Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'MRD Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'Room',
                    column_group: 'rate',
                }, {
                    id: 1,
                    name: 'amount',
                    title: 'MRD Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'MRD Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'Room',
                    column_group: 'amount',
                }]
            }, {
                'id:': 2,
                'feilds': [{
                    id: 2,
                    name: 'ricam_choose',
                    title: 'Seropositive',
                    visible: true,
                    icon: 'number',
                    element: 'select',
                    required: true,
                    type: 'select',
                    placeholder: 'Seropositive',
                    rules: [],
                    errors: [],
                    value: 1,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'ICU',
                    column_group: 'qty',
                }, {
                    id: 2,
                    name: 'qty',
                    title: 'Seropositive Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Seropositive Quantity',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',

                    disable: false,
                    className: 'col-3',
                    row_group: 'ICU',
                    column_group: 'qty',
                }, {
                    id: 2,
                    name: 'rate',
                    title: 'Seropositive Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Seropositive Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'ICU',
                    column_group: 'rate',
                }, {
                    id: 2,
                    name: 'amount',
                    title: 'Seropositive Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Seropositive Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'ICU',
                    column_group: 'amount',
                }]
            }]
        }
    }, {
        id: 14,
        name: 'isolation_charges',
        title: 'Isolation Charges',
        visible: true,
        Specification: {
            'type': 'table',
            'add_more': false,
            'add_more_title': null,
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Service Name', width: "30%" }, { 'id': 3, 'text': 'Quantity', width: "15%" }, { 'id': 4, 'text': 'Rate (Rs.)', width: "15%" }, { 'id': 5, 'text': 'Amount (Rs.)', width: "35%" }],
            'table_body': [{
                'id:': 1,
                'feilds': [{
                    id: 2,
                    name: 'ricam_choose',
                    title: 'Room',
                    visible: true,
                    icon: 'number',
                    element: 'select',
                    required: true,
                    type: 'select',
                    placeholder: 'Room',
                    rules: [],
                    errors: [],
                    value: 1,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'ICU',
                    column_group: 'qty',

                }, {
                    id: 1,
                    name: 'qty',
                    title: 'Room Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Room Quantity',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'Room',
                    column_group: 'qty',
                }, {
                    id: 1,
                    name: 'rate',
                    title: 'Room Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Room Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'Room',
                    column_group: 'rate',
                }, {
                    id: 1,
                    name: 'amount',
                    title: 'Room Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Room Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'Room',
                    column_group: 'amount',
                }]
            }, {
                'id:': 2,
                'feilds': [{
                    id: 2,
                    name: 'ricam_choose',
                    title: 'ICU',
                    visible: true,
                    icon: 'number',
                    element: 'select',
                    required: true,
                    type: 'select',
                    placeholder: 'ICU',
                    rules: [],
                    errors: [],
                    value: 1,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'ICU',
                    column_group: 'qty',
                }, {
                    id: 2,
                    name: 'qty',
                    title: 'ICU Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'ICU Quantity',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'ICU',
                    column_group: 'qty',
                }, {
                    id: 2,
                    name: 'rate',
                    title: 'ICU Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'ICU Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'ICU',
                    column_group: 'rate',
                }, {
                    id: 2,
                    name: 'amount',
                    title: 'ICU Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'ICU Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'ICU',
                    column_group: 'amount',
                }]
            }]
        }
    }, {
        id: 15,
        name: 'physiotherapy_diet_charges',
        title: 'Physiotherapy & Diet Charges',
        visible: true,
        Specification: {
            'type': 'table',
            'add_more': false,
            'add_more_title': null,
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Service Name', width: "30%" }, { 'id': 3, 'text': 'Quantity', width: "15%" }, { 'id': 4, 'text': 'Rate (Rs.)', width: "15%" }, { 'id': 5, 'text': 'Amount (Rs.)', width: "35%" }],
            'table_body': [{
                'id:': 1,
                'feilds': [{
                    id: 2,
                    name: 'ricam_choose',
                    title: 'Dietician',
                    visible: true,
                    icon: 'number',
                    element: 'select',
                    required: true,
                    type: 'select',
                    placeholder: 'Dietician',
                    rules: [],
                    errors: [],
                    value: 1,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'ICU',
                    column_group: 'qty',
                }, {
                    id: 1,
                    name: 'qty',
                    title: 'Dietician Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Dietician Quantity',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'Room',
                    column_group: 'qty',
                }, {
                    id: 1,
                    name: 'rate',
                    title: 'Dietician Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Dietician Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'Room',
                    column_group: 'rate',
                }, {
                    id: 1,
                    name: 'amount',
                    title: 'Dietician Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Dietician Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'Room',
                    column_group: 'amount',
                }]
            }, {
                'id:': 2,
                'feilds': [{
                    id: 2,
                    name: 'ricam_choose',
                    title: 'Physiotherapy',
                    visible: true,
                    icon: 'number',
                    element: 'select',
                    required: true,
                    type: 'select',
                    placeholder: 'Physiotherapy',
                    rules: [],
                    errors: [],
                    value: 1,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'ICU',
                    column_group: 'qty',

                }, {
                    id: 2,
                    name: 'qty',
                    title: 'Physiotherapy Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Physiotherapy Quantity',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'ICU',
                    column_group: 'qty',
                }, {
                    id: 2,
                    name: 'rate',
                    title: 'Physiotherapy Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Physiotherapy Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'ICU',
                    column_group: 'rate',
                }, {
                    id: 2,
                    name: 'amount',
                    title: 'Physiotherapy Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Physiotherapy Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'ICU',
                    column_group: 'amount',
                }]
            }]
        }
    }, {
        id: 16,
        name: 'professional_fees',
        title: 'Professional Fees',
        visible: true,
        Specification: {
            'type': 'table',
            'add_more': false,
            'add_more_title': null,
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Service Name', width: "30%" }, { 'id': 3, 'text': 'Quantity', width: "15%" }, { 'id': 4, 'text': 'Rate (Rs.)', width: "15%" }, { 'id': 5, 'text': 'Amount (Rs.)', width: "35%" }],
            'table_body': [{
                'id:': 1,
                'feilds': [{
                    id: 1,
                    name: 'professional_fees',
                    title: 'Professional Fees',
                    visible: true,
                    element: 'text',

                }, {
                    id: 1,
                    name: 'qty',
                    title: '',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Quantity',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'Room',
                    column_group: 'qty',
                }, {
                    id: 1,
                    name: 'rate',
                    title: '',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'Room',
                    column_group: 'rate',
                }, {
                    id: 1,
                    name: 'amount',
                    title: 'Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'Room',
                    column_group: 'amount',
                }]
            }]
        }
    }, {
        id: 17,
        name: 'surgical_charges',
        title: 'Surgical Charges',
        visible: true,
        Specification: {
            'type': 'table',
            'add_more': false,
            'add_more_title': null,
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Service Name', width: "30%" }, { 'id': 3, 'text': 'Quantity', width: "15%" }, { 'id': 4, 'text': 'Rate (Rs.)', width: "15%" }, { 'id': 5, 'text': 'Amount (Rs.)', width: "35%" }],
            'table_body': [{
                'id:': 1,
                'feilds': [{
                    id: 1,
                    name: 'surgeon',
                    title: 'Surgeon',
                    visible: true,
                    element: 'text',

                }, {
                    id: 1,
                    name: 'qty',
                    title: 'Surgeon Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Surgeon Quantity',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'Room',
                    column_group: 'qty',
                }, {
                    id: 1,
                    name: 'rate',
                    title: 'Surgeon Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Surgeon Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'Room',
                    column_group: 'rate',
                }, {
                    id: 1,
                    name: 'amount',
                    title: 'Surgeon Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Surgeon Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'Room',
                    column_group: 'amount',
                }]
            }, {
                'id:': 2,
                'feilds': [{
                    id: 1,
                    name: 'asst_surgeon',
                    title: 'Asst Surgeon',
                    visible: true,
                    element: 'text',

                }, {
                    id: 2,
                    name: 'qty',
                    title: 'Asst Surgeon Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Asst Surgeon Quantity',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',

                    disable: true,
                    className: 'col-3',
                    row_group: 'ICU',
                    column_group: 'qty',
                }, {
                    id: 2,
                    name: 'rate',
                    title: 'Asst Surgeon Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Asst Surgeon Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'ICU',
                    column_group: 'rate',
                }, {
                    id: 2,
                    name: 'amount',
                    title: 'Asst Surgeon Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Asst Surgeon Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'ICU',
                    column_group: 'amount',
                }]
            }, {
                'id:': 3,
                'feilds': [{
                    id: 1,
                    name: 'anaesthetist',
                    title: 'Anaesthetist',
                    visible: true,
                    element: 'text',

                }, {
                    id: 1,
                    name: 'qty',
                    title: 'Anaesthetist Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Anaesthetist Quantity',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'Room',
                    column_group: 'qty',
                }, {
                    id: 1,
                    name: 'rate',
                    title: 'Anaesthetist Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Anaesthetist Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'Room',
                    column_group: 'rate',
                }, {
                    id: 1,
                    name: 'amount',
                    title: 'Anaesthetist Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Anaesthetist Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'Room',
                    column_group: 'amount',
                }]
            }, {
                'id:': 4,
                'feilds': [{
                    id: 1,
                    name: 'asst_anaesthetist',
                    title: 'Asst Anaesthetist',
                    visible: true,
                    element: 'text',

                }, {
                    id: 2,
                    name: 'qty',
                    title: 'Asst Anaesthetist Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Asst Anaesthetist Quantity',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',

                    disable: true,
                    className: 'col-3',
                    row_group: 'ICU',
                    column_group: 'qty',
                }, {
                    id: 2,
                    name: 'rate',
                    title: 'Asst Anaesthetist Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Asst Anaesthetist Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'ICU',
                    column_group: 'rate',
                }, {
                    id: 2,
                    name: 'amount',
                    title: 'Asst Anaesthetist Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Asst Anaesthetist Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'ICU',
                    column_group: 'amount',
                }]
            }
            ]
        }
    }, {
        id: 18,
        name: 'medical_charges',
        title: 'Medical Charges',
        visible: true,
        Specification: {
            'type': 'table',
            'add_more': false,
            'add_more_title': null,
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Service Name', width: "30%" }, { 'id': 3, 'text': 'Quantity', width: "15%" }, { 'id': 4, 'text': 'Rate (Rs.)', width: "15%" }, { 'id': 5, 'text': 'Amount (Rs.)', width: "35%" }],
            'table_body': [{
                'id:': 1,
                'feilds': [{
                    id: 1,
                    name: 'physician_fees',
                    title: 'Physician Fees',
                    visible: true,
                    element: 'text',

                }, {
                    id: 1,
                    name: 'qty',
                    title: 'Physician Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Physician Quantity',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'Room',
                    column_group: 'qty',
                }, {
                    id: 1,
                    name: 'rate',
                    title: 'Physician Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Physician Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'Room',
                    column_group: 'rate',
                }, {
                    id: 1,
                    name: 'amount',
                    title: 'Physician Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Physician Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'Room',
                    column_group: 'amount',
                }]
            }, {
                'id:': 2,
                'feilds': [{
                    id: 1,
                    name: 'asst_physician_fees',
                    title: 'Asst Physician Fees',
                    visible: true,
                    element: 'text',

                }, {
                    id: 2,
                    name: 'qty',
                    title: 'Asst Physician Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Asst Physician Quantity',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',

                    disable: true,
                    className: 'col-3',
                    row_group: 'ICU',
                    column_group: 'qty',
                }, {
                    id: 2,
                    name: 'rate',
                    title: 'Asst Physician Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Asst Physician Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'ICU',
                    column_group: 'rate',
                }, {
                    id: 2,
                    name: 'amount',
                    title: 'Asst Physician Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Asst Physician Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'ICU',
                    column_group: 'amount',
                }]
            }, {
                'id:': 3,
                'feilds': [{
                    id: 1,
                    name: 'intensivist',
                    title: 'Intensivist',
                    visible: true,
                    element: 'text',

                }, {
                    id: 1,
                    name: 'intensivist_qty',
                    title: 'Intensivist Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Intensivist Quantity',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'Room',
                    column_group: 'qty',
                }, {
                    id: 1,
                    name: 'rate',
                    title: 'Intensivist Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Intensivist Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'Room',
                    column_group: 'rate',
                }, {
                    id: 1,
                    name: 'amount',
                    title: 'Intensivist Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Intensivist Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'Room',
                    column_group: 'amount',
                }]
            }, {
                'id:': 4,
                'feilds': [{
                    id: 1,
                    name: 'asst_intensivist',
                    title: 'Asst Intensivist',
                    visible: true,
                    element: 'text',

                }, {
                    id: 2,
                    name: 'asst_intensivist_qty',
                    title: 'Asst Intensivist Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Asst Intensivist Quantity',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',

                    disable: true,
                    className: 'col-3',
                    row_group: 'ICU',
                    column_group: 'qty',
                }, {
                    id: 2,
                    name: 'rate',
                    title: 'Asst Intensivist Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Asst Intensivist Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'ICU',
                    column_group: 'rate',
                }, {
                    id: 2,
                    name: 'amount',
                    title: 'Asst Intensivist Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Asst Intensivist Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'ICU',
                    column_group: 'amount',
                }]
            }
            ]
        }
    }]
}

const roomtypeSchema = {
    feilds: [{
        id: 1,
        name: 'roomtypes',
        title: 'Select Room',
        visible: true,
        icon: 'number',
        element: 'select',
        required: true,
        type: 'select',
        placeholder: 'Select',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mx-auto',
    }]
}

const includesSchema = {
    feilds: [{
        id: 1,
        name: 'includes',
        title: 'Includes',
        visible: true,
        Specification: {
            'type': 'table',
            'add_more': false,
            'add_more_title': null,
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Service Name', width: "20%" }, { 'id': 3, 'text': 'Quantity', width: "25%" }, { 'id': 4, 'text': 'Rate (Rs.)', width: "25%" }, { 'id': 5, 'text': 'Amount (Rs.)', width: "25%" }],
            'table_body': [{
                'id:': 1,

                'feilds': [{
                    id: 1,
                    name: 'item_service',
                    title: 'Item / Service',
                    visible: true,
                    element: 'text',

                }, {
                    id: 1,
                    name: 'includes_qty',
                    title: 'Includes Qty.',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Includes Quantity',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'Room',
                    column_group: 'qty',
                }, {
                    id: 1,
                    name: 'includes_rate',
                    title: 'Includes Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Includes Quantity',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'Room',
                    column_group: 'rate',
                }, {
                    id: 1,
                    name: 'includes_amount',
                    title: 'Includes Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Includes Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'Room',
                    column_group: 'amount',
                }]
            }]
        }
    }]
}

const excludesSchema = {
    feilds: [{
        id: 1,
        name: 'exlcudes',
        title: 'Excludes',
        visible: true,
        Specification: {
            'type': 'table',
            'add_more': true,
            'add_more_title': 'Add More',
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Service Name', width: "20%" }, { 'id': 3, 'text': 'Quantity', width: "18%" }, { 'id': 4, 'text': 'Rate (Rs.)', width: "18%" }, { 'id': 5, 'text': 'Amount (Rs.)', width: "18%" }, { 'id': 6, 'text': 'Action', width: "5%" }],
            'table_body': [{
                'id:': 1,
                'text': 'item_service',
                'type': 'Item / Service',
                'input_feild': [],
                'feilds': [{
                    id: 1,
                    name: 'item_service',
                    title: 'Item / Service',
                    visible: true,
                    element: 'text',

                }, {
                    id: 1,
                    name: 'qty',
                    title: '',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Item / Service Quantity',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'w-100',
                    row_group: 'Routine',
                    column_group: 'qty',
                }, {
                    id: 1,
                    name: 'rate',
                    title: 'Item / Service Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Item / Service Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'Routine',
                    column_group: 'rate',
                }, {
                    id: 1,
                    name: 'amount',
                    title: 'Item / Service Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Item / Service Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'Routine',
                    column_group: 'amount',
                }, {
                    id: 1,
                    name: 'action',
                    title: '--',
                    visible: true,
                    element: 'text',

                },]
            }],
            'add_more_feilds': [{
                id: 1,
                name: 'choose',
                title: '',
                visible: true,
                icon: 'number',
                element: 'select',
                required: true,
                type: 'select',
                placeholder: 'Item / Service',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: false,
                className: 'col-12 p-0',
                row_group: 'Highend',
                column_group: 'choose',
            }, {
                id: 1,
                name: 'qty',
                title: 'Item / Service Qty.',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Item / Service Quantity',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: false,
                className: 'col-3',
                row_group: 'Highend',
                column_group: 'qty',
            }, {
                id: 1,
                name: 'rate',
                title: 'Item / Service Rate',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Item / Service Rate',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'Highend',
                column_group: 'rate',
            }, {
                id: 1,
                name: 'amount',
                title: 'Item / Service Amount',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Item / Service Amount',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'Highend',
                column_group: 'amount',
            }, {
                id: 1,
                name: 'action',
                title: '--',
                visible: true,
                element: 'action',

            }],
        }
    }]
}

const excludesAddMoreSchema = {
    feilds: [{
        name: 'pre_existing_group',
        data: [{
            id: 1,
            name: 'choose',
            title: 'Enter Excludes',
            visible: true,
            icon: 'number',
            element: 'input',
            required: true,
            type: 'text',
            placeholder: 'Enter Excludes',
            rules: [],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-3',
            row_group: 'Highend',
            column_group: 'choose',
        }, {
            id: 1,
            name: 'qty',
            title: 'Qty.',
            visible: true,
            icon: 'number',
            element: 'input',
            required: true,
            type: 'number',
            placeholder: 'Qty',
            rules: [],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-3',
            row_group: 'Highend',
            column_group: 'qty',
        }, {
            id: 1,
            name: 'rate',
            title: 'Rate',
            visible: true,
            icon: 'number',
            element: 'input',
            required: true,
            type: 'number',
            placeholder: 'Rate',
            rules: [],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-3',
            row_group: 'Highend',
            column_group: 'rate',
        }, {
            id: 1,
            name: 'amount',
            title: 'Amount',
            visible: true,
            icon: 'number',
            element: 'input',
            required: true,
            type: 'number',
            placeholder: 'Amount',
            rules: [],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-3',
            row_group: 'Highend',
            column_group: 'amount',
        }]
    }]
}

export { basicDetailsSchema, employeeDetailsSchema, medicationDetailsSchema, estimateBreakupFormatSchema, addonSchema, roomtypeSchema, includesSchema, excludesSchema, excludesAddMoreSchema };